import React, { Component } from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";

import * as x from "../../styles/css";

class Button extends Component {
	render() {
		return (
			<View
				style={[
					x.my.one,
					styles.button,
					this.props.disabled ? { opacity: 0.5 } : {},
					this.props.color
						? { backgroundColor: this.props.color }
						: {},
					this.props.style,
				]}
			>
				<TouchableOpacity
					disabled={this.props.disabled}
					onPress={this.props.onPress}
					style={[
						x.alignItems.center,
						x.justifyContent.center,
						styles.button,
					]}
				>
					<Text style={[x.px.three, styles.title]}>
						{this.props.title.toUpperCase()}
					</Text>
				</TouchableOpacity>
			</View>
		);
	}
}

const styles = StyleSheet.create({
	title: {
		color: "white",
		fontSize: 18,
		fontWeight: "300",
		textAlign: "center",
	},
	button: {
		height: 60,
	},
});

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js